export enum LocalStorageEnum {
  token = '_t',
  user_id = '_u',
  refresh_token = '_rft',
  permissions = '_perm',
  role = '_r',
  language = '_lang'
}
